import { Image } from "antd";
import React, { useEffect, useState } from "react";
import "./BlogsSingelPage.scss";
import { useParams } from "react-router";
import parse from "html-react-parser";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { HomeOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";
import Api from "../../network/ApiConfig";
const BlogsSingelPage = () => {
  const [blogs, setBlogs] = useState({});
  const { currentLang } = useSelector((state) => state?.user);
  const { id } = useParams();
  useEffect(() => {
    Api.get(`Blogs/GetById?Id=${id}`)
      .then((res) => {
        setBlogs(res.data.model);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, [id]);
  // console.log(id);
  // console.log(blogs);
  return (
    <>
      <Helmet>
        <title>
          {currentLang === "en"
            ? parse(blogs?.Title || "")
            : parse(blogs?.TitleLT || "")}
        </title>
        <meta
          name="description"
          content={
            currentLang === "en"
              ? parse(blogs?.Description || "")
              : parse(blogs?.DescriptionLT || "")
          }
        />
      </Helmet>
      <div className="blogs_details">
        <div className="container">
          <div className="header-first">
            <Breadcrumb separator=">">
              <Breadcrumb.Item>
                <Link to="/home">
                  <HomeOutlined />
                  <p className="link-name">الرئيسية</p>
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/blogs">
                  <p className="link-name">المدونات</p>
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item className="last-bread">
                {" "}
                {currentLang === "en"
                  ? parse(blogs?.Title || "")
                  : parse(blogs?.TitleLT || "")}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Image preview={false} src={blogs.Image} />
          <div className="blogs_container">
            <div className="conteint">
              <h2 className="blogs_conteint_title">
                {currentLang === "en"
                  ? parse(blogs?.Title || "")
                  : parse(blogs?.TitleLT || "")}
              </h2>
              <p>
                {currentLang === "en"
                  ? parse(blogs?.DescriptionLT || "")
                  : parse(blogs?.DescriptionLT || "")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogsSingelPage;
